import { EOfferSeller } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IOfferSellerTypesTagType = 'advanced-offerSeller';

export interface IOfferSellerTypesTag {
  type: 'advanced-offerSeller';
  value: EOfferSeller;
}

function isOfferSellerTypesTag(tag: TTag): tag is IOfferSellerTypesTag {
  return tag.type === IOfferSellerTypesTagType;
}

export const offerSellerTypesTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.offer_seller_type && jsonQuery.offer_seller_type.value;

    let nextTags = tags.filter(
      tag => tag.type !== IOfferSellerTypesTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EOfferSeller) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IOfferSellerTypesTag => isOfferSellerTypesTag(tag) && tag.value === value,
            () => ({ type: IOfferSellerTypesTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
